// To hold menu & header in tandem, grouped and tethered to the page
export const wrapper = "w1nh2egm";
export const container = "cc675z2";
export const menuVisible = "m15vb5d6";

/* Wrapper for navigation container */
export const navigation = "n17k9wxi";
export const roundBottom = "r1r6f1xj";
export const logo = "l1wlqjqo";
export const phone = "pn07h8h";
export const endSection = "etdtjl5";
export const avatar = "a1eyef2x";
export const searchContainer = "sk9em3v";
export const searchMenu = "s1cmr38f";

/* Dropdown wrapper to align the parent tab */
export const dropdown = "d2xh268";

/* Dropdown menu styling */
export const dropdownMenu = "d1ust678";

/* Chevron alignment */
export const chevron = "cv5dmy0";
export const dropdownMenuItem = "d1wx6em6";

require("./style.linaria.module.css!=!../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./style.ts");